import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import queryString from 'query-string';
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import FirebaseService from "../../firebase/FirebaseService";
import './login.scss';


export default function Validacao() {

    const location = useLocation();

    const [titulo, setTitulo] = useState('');
    const [mensagem, setMensagem] = useState('');
    const [mode, setMode] = useState('');
    const [oobCode, setOobCode] = useState('');
    const [novaSenha, setNovaSenha] = useState('');
    const [confirmacaoNovaSenha, setConfirmacaoNovaSenha] = useState('');
    const navigate = useNavigate();

    useEffect(() => {

        const auth = FirebaseService.getApp().auth();
        const url = queryString.parse(location.search);
        const modeLocal = url.mode;
        const oobCodeLocal = url.oobCode;

        if (typeof modeLocal === 'string') {
            setMode(modeLocal);
        } else {
            setMode('');
        }

        if (typeof oobCodeLocal === 'string') {
            setOobCode(oobCodeLocal);
        } else {
            setOobCode('');
        }

        if (modeLocal === 'verifyEmail') {
            setTitulo('Verificação de e-mail');
            setMensagem('aguarde...');

            auth.applyActionCode(oobCode).then((resp) => {
                setMensagem('E-mail verificado com sucesso');
            }).catch(e => {
                setMensagem('Solicitação inválida');
                console.warn(e);
            });

        } else if (modeLocal === 'resetPassword') {
            setTitulo('Recuperação de senha');
        }

    }, []);

    function alterarSenha() {
        if (mode === 'resetPassword') {

            if (novaSenha === confirmacaoNovaSenha) {

                const auth = FirebaseService.getApp().auth();
                auth.verifyPasswordResetCode(oobCode).then(email => {
                    auth.confirmPasswordReset(oobCode, novaSenha).then(resp => {
                        setMensagem('Senha alterada com sucesso');
                        setMode('0')
                    }).catch(e => {
                        console.warn(e);
                        if (e.code === 'auth/weak-password') {
                            setMensagem('Favor informar uma senha mais forte, mínimo 6 caracteres');
                        } else {
                            setMensagem('Solicitação inválida');
                        }
                    });
                }).catch(e => {
                    setMensagem('Solicitação inválida');
                    console.warn(e);
                });
            } else {
                setMensagem('As senhas devem ser iguais');
            }
        }
    }

    return (
        <div className="login">
            <div className="login-center">
                <div className="row">
                    <div className="col-sm-12">
                        <img src='/empx.png' className="login-img-logo" alt="logo" />
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        <span>{titulo}</span>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        <span style={{ fontWeight: 'bold', color: 'red' }}>{mensagem}</span>
                    </div>
                </div>
                {mode === 'resetPassword' ? (
                    <>
                        <div className="row">
                            <div className="col-sm-12">
                                <InputText className="login-input" autoFocus={true} type="password" id="password" name="password" placeholder="Nova Senha" value={novaSenha} onChange={(e) => setNovaSenha(e.target.value)} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12">
                                <InputText className="login-input" type="password" id="password" name="password" placeholder="Repita a nova senha" value={confirmacaoNovaSenha} onChange={(e) => setConfirmacaoNovaSenha(e.target.value)} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12">
                                <Button className='login-botao' label="Alterar" onClick={() => alterarSenha()} />
                            </div>
                        </div>
                    </>
                ) : mode === '0' ? (
                    <div className="row">
                        <div className="col-sm-12">
                            <a href='/'>Voltar para o login</a>
                        </div>
                    </div>
                ) : null}
            </div>
        </div>
    )
}